import { BaseDetailPage } from 'src/app/@shared/base-detail-page';
import { Component, Input, inject } from '@angular/core';

import { DatasetFormCompleteStatus } from 'src/app/@shared/form/base-form.component';
import { ToastService } from 'src/app/@core/toast.service';
import { TopicModel } from 'src/app/topic/@shared/topic.model';

@Component({
  selector: 'page-topic-edit',
  standalone: false,
  styleUrls: ['./topic-edit.page.scss'],
  templateUrl: './topic-edit.page.html',
})
export class TopicEditPage extends BaseDetailPage<TopicModel> {
  @Input() public item: TopicModel;

  public readonly pageTrackName = 'TopicEditPage';

  public isEditMode: boolean;

  protected isStaticPage: boolean = true;

  private toastService = inject(ToastService);

  public onProcessCompleted(processCompleted: DatasetFormCompleteStatus): void {
    switch (processCompleted) {
      case 'submitted':
        this.toastService.show(this.translate.instant('VIEW.COMMON.TOAST.SAVE_SUCCESS.MESSAGE')).catch();
        this.back().catch();
        break;

      case 'error':
        this.toastService.show(this.translate.instant('VIEW.COMMON.TOAST.SAVE_ERROR.MESSAGE'), {
          color: 'danger',
        }).catch();
        break;

      default:
        this.back().catch();
        break;
    }
  }

  public async back(): Promise<void> {
    await this.modalController.dismiss();

    return Promise.resolve();
  }

  protected protoOnInit(): void {
    this.isEditMode = !!this.item?.id;
  }
}
